var GLOBALCTX = window;

/**
 * 获取全局数据仓库
 */
function getStore() {
    if (!GLOBALCTX._$V3GlobalDataStore$_) {
        GLOBALCTX._$V3GlobalDataStore$_ = {};
    }
    return GLOBALCTX._$V3GlobalDataStore$_;
}
/**
 * 添加全局数据，如果key值已存在，则报错
 * @param   {String} key
 * @param   {Object} val
 */
function put(key,val) {
    var store = getStore();
    if(store.hasOwnProperty(key)){
        throw new Error("全局数据已存在key: " + key + ", 请检查.");
    }else{
        store[key] = val;
    }
}
/**
 * 根据key获取数据
 * @param {String} key 
 */
function get(key) {
    var store = getStore();
    return store[key];
}
/**
 * 添加全局数据
 * @param   {String} key
 * @param   {Object} val
 */
function meger(key,val) {
    var store = getStore();
    store[key] = val;
}
/**
 * 判断key是否存在
 * @param {String} key 
 * @returns {Boolean} true表示存在key，false表示不存在key
 */
function exists(key) {
    var store = getStore();
    return store.hasOwnProperty(key);
}

export default {
    put:put,
    get:get,
    meger:meger,
    exists:exists,
    datas: getStore()
};


// WEBPACK FOOTER //
// ./src/Global.js